import { CSSProperties, ReactNode } from 'react';

export enum AlertTypes {
    PRIMARY = 'primary',
    SUCCESS = 'success',
    WARNING = 'warning',
    INFO = 'info',
}

export type ModalType = {
    isActive?: boolean;
    modalClasses?: string;
    className?: string;
    params?: string;
    title?: string;
    component?: string;
    subTitle?: string;
    contentClass?: string;
    animationClassShow?: string;
    content?: string | ReactNode;
    isCrossHidden?: boolean;
    shouldDisableHideOnOverlay?: boolean;
    picto?: ReactNode;
    modalStyle?: CSSProperties;
};

export type LoadingType = {
    show: boolean;
    message?: string;
};

export type SnackbarType = {
    show: boolean;
    message?: string;
    alertType?: AlertTypes;
    autoHideDuration?: number;
};
